import React from 'react';
import styles from './DisabledMask.module.scss';

interface Props {
  active: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
}

const DisabledMask: React.FC<Props> = props => {
  const { active, children, style, wrapperStyle } = props;
  if (!active) {
    return <>{children}</>;
  }
  return (
    <div style={wrapperStyle} className={styles.wrapper}>
      {children}
      <div style={style} className={styles.mask} />
    </div>
  );
};

export default DisabledMask;
